import { IFilter } from "src/@redux/listRedux";
import commonDataAccess from "../commonDataAccess";

class PricebookDataAccess {
  savePricebook(data: any, moduleName: any) {
    return commonDataAccess.postData(
      "pricebook/save/pricebook",
      data,
      {},
      null,
      moduleName,
    );
  }
  updatePricebookPrice(id: any, type: any, priceChange: any) {
    return commonDataAccess.postData("pricebook/update/pricechange", null, {
      id: id,
      type: type,
      priceChangeInPercentage: priceChange,
    });
  }
  savePricebookDetail(data: any) {
    return commonDataAccess.postData("pricebook/save/pricebookdetail", data);
  }
  getPricebook(pricebookId: any, moduleName: any) {
    return commonDataAccess.getData(
      "pricebook/get/pricebook",
      {
        id: pricebookId,
      },
      moduleName,
    );
  }
  getAll = (
    params: {
      pageNo;
      pageSize;
      sortData;
      filters: Array<IFilter>;
      pricebooktype;
    },
    moduleName,
  ) => {
    let _filters = {};
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };

    return commonDataAccess.getData(
      "pricebook/get/" + params.pricebooktype + "PricebookList",
      parameters,
      moduleName,
    );
  };
  // deleteById = (id: number) => {
  //   return commonDataAccess.deleteData("pricebook/delete", {
  //     id: id,
  //   });
  // };
  deleteById = async (ids: string, moduleName: string) => {
    var result = await commonDataAccess.deleteData(
      "pricebook/delete",
      {
        ids: ids,
      },
      moduleName,
    );
    return result;
  };
  deletepriceBookDetailsById = async (id: any, moduleName: any) => {
    var result = await commonDataAccess.deleteData(
      "pricebook/deletePriceBookDetails",
      { id: id },
      moduleName,
    );
    return result;
  };
}

export default new PricebookDataAccess();
